//devUrl:测试环境的地址
//let devUrl = '/richin/dev'; // 测试环境
let devUrl = 'http://110.41.7.145:18088'; // KW测试环境
export { devUrl };
